import React from 'react';
import { PanelLayout } from '../../../../layout/Panel/Panel';
import IconComponent from '../../../../shared/IconComponents/IconComponent';
import { TextCustom } from '../../../../ui/TextCustom';
import { SpacingCustom } from '../../../../layout/Spacing/SpacingCustom';
import { Spacing } from '../../../../layout/Spacing/Spacing';
import { FlexBetween } from '../../../../layout/FlexBetween/FlexBetween';

interface IDetailCardProps {
    fileIcon: string;
    fileName: string;
    commitData: string;
    version: string;
}

export const DetailCard: React.FC<IDetailCardProps> = ({ fileIcon, fileName, commitData, version }) => {
    return (
        <PanelLayout hasShadow={false} color="white">
            <Spacing paddingSpacing="none" marginSpacing="m">
                <SpacingCustom paddingTop={0.2} paddingBottom={0.2}>
                    <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
                        <SpacingCustom paddingLeft={0.5}>
                            <IconComponent size={3} iconName={'File'} />
                        </SpacingCustom>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'start', gap: '.3rem' }}>
                            <FlexBetween>
                                <TextCustom weight={900} size={1.2} color="dark">
                                    {fileName}.mdl
                                </TextCustom>
                                <IconComponent size={1.6} iconName={'OK'}/>
                            </FlexBetween>
                            <FlexBetween>
                                <TextCustom weight={600} color="grey-dark">
                                    Version:{' '}
                                </TextCustom>
                                <TextCustom weight={600} color="grey-normal">
                                    {version}
                                </TextCustom>
                            </FlexBetween>
                            <FlexBetween>
                                <TextCustom weight={600} color="grey-dark">
                                    Version date:{' '}
                                </TextCustom>
                                <TextCustom weight={600} color="grey-normal">
                                    {commitData}
                                </TextCustom>
                            </FlexBetween>
                        </div>
                    </div>
                </SpacingCustom>
            </Spacing>
        </PanelLayout>
    );
};
